import type { FinanceCapabilities } from "../api/types";

export function canAccessDedicatedPayouts(capabilities: FinanceCapabilities): boolean {
  return capabilities.canViewPayouts;
}
